// all application settings
var Settings = {
    parseAppId: 'gloadso',
    parseKey: '',
    parseUrl: 'https://gloadso.herokuapp.com/parse',
    deepLinkUrl: '',
	supportClientId: 'qQr81H5sqj',
    login: false,
    permissions: {
		"userViewer":"",
		"reportViewer":"reports",
		"categoryViewer":"reports",
		"personalViewer":"",
		"profileViewer":"",
		"useraddViewer":"addusers",
		"profilesViewer":"profiles",
		"usersViewer":"consultusers",
		"sendpushnotificationsViewer":"news",
		"admincategoriesViewer":"admincategories",
		"chartsViewer":"reportcharts",
		"tragraphsViewer":"usercharts",
		'newsViewer':"news",
	},
	allowreubicarreports : true,
	pushNotifPublicKey: 'BDIa1BGGtqlq1RkvA2yDJSrg2MwkDxkBekWKm1RSiUwa3y6QXEDIVtqFmxtQyS0iWwIq8xVSlogD0bkRckEeeeQ',

};

window.arrlang = {
	"en": {
		"OptMenu1" : "Reports",
		"OptMenu2" : "Saved Reports",
		"OptMenu3" : "Users",
		"SubmenuOpt1" : "Add User",
		"SubmenuOpt2" : "Consult User",
		"SubmenuOpt3" : "Profiles",
		"FooterMenuOpt1" : "Home",
		"FooterMenuOpt2" : "Profile",
		"FooterMenuOpt3" : "Log Out",
	},
	'es' : {
		"ListUsersTittle" : "Lista de Usuarios",
		"DeleteUser" : "Eliminar Usuario",
		"UserNotDeleted" : "Usuario no Eliminado",
		"DeleteNews" : "Eliminar Noticia",
		"NewsNotDeleted" : "Noticia no Eliminada",
		"Charttittle" : "Gráfico General",
		"YearsRange" : "Rango de Años",
		"QuantReports" : "Cantidad de Reportes",
		"Sunday" : "Domingo",//sin traducir
		"Monday" : "Lunes",//sin traducir
		"Tuesday" : "Martes",//sin traducir
		"Wednesday" : "Miércoles",//sin traducir
		"Thursday" : "Jueves",//sin traducir
		"Friday" : "Viernes",//sin traducir
		"Saturday" : "Sábado",//sin traduci
		"Januarylong" : "Enero",//sin traducir
		"Februarylong" : "Febrero",//sin traducir
		"Marchlong" : "Marzo",//sin traducir
		"Aprillong" : "Abril",//sin traducir
		"Maylong"  : "Mayo",//sin traducir
		"Junelong" : "Junio",//sin traducir
		"Julylong" : "Julio",//sin traducir
		"Augustlong" : "Agosto",//sin traducir
		"Septemberlong" : "Septiembre",//sin traducir
		"Octoberlong"  : "Octubre",//sin traducir
		"Novemberlong" : "Noviembre",//sin traducir
		"Decemberlong" : "Diciembre",
		"Monthrange" : "Rango de meses:",
		"January" : "Ene",//monthsof the year //sin traducir
		"February" : "Feb",//sin traducir
		"March" : "Mar",//sin traducir
		"April" : "Abr",//sin traducir
		"May" : "May",//sin traducir
		"June" : "Jun",//sin traducir
		"July" : "Jul",//sin traducir
		"August" : "Ago",//sin traducir
		"September" : "Sep",//sin traducir
		"October" : "Oct",//sin traducir
		"November" : "Nov",//sin traducir
		"December" : "Dic",//sin traducir
		"daysx" : ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'],
		"EnterAdminCategUser" : 'Elegir Usuario',////sin traducir
		"SaveCateAdminBtn" : "Guardar",////sin traducir
		"NoAdminforCateg" : "Sin Definir",////sin traducir
		"Errorpushnot" : "Por favor Llenar Los Dos Campos para Enviar Notificaciones.",//sin traducir
		"confirmsendpushnot" : "Por favor confirmar el envío de la notificación a todos los usuarios.",//sin traducir
		"confirmsendpushnotmessage" : "Se envío la notificación correctamente.",//sin traducir
		"selnewreport" : "Nuevos",
		"selasginreport" : "Asignados",
		"selarchivereport" : "Archivados",
		"Asign" : "Categorías de reportes Asignados",
		"New" : "Categorías de reportes Nuevos",
		"Archive" : "Categorías de reportes Archivados",
		"asigntittle2" : "Mostrando reportes Asignados",
		"newtittle2" : "Mostrando reportes Nuevos",
		"archivetittle2" : "Mostrando reportes Archivados",
		"NoFilestodiscard" : "No hay archivos para Descartar",
		"NoFilestosave": "No hay archivos para guardar",
		"Filetstosave":"Guardar Archivos",
		"Filetsnotsave":"Archivos no Guardados",
		"filesnotest":"Archivos de la nota: ",
		"AsignedReportMessage": "Reporte asignado correctamente",
		"PriorityReportMessage": "Reporte priorizado correctamente",
		"NoteFilestext" : "Archivos Adjuntos",
		"NoFilestoshow" : "No hay archivos que mostrar.",
		"LoadReport" : "Cargando reporte ",
		"messagetochangestatus": "Por favor indicar el motivo de cerrar el reporte:",
		"messagetochangestatus2": "Por favor indicar el motivo de descarte el reporte:",
		"SaveStateok": "Estado guardado correctamente",
		"messagetochangestatus3": "Por favor indicar el motivo del cambio de estado del reporte",
		"tableheaderrecive" : "Reportes Totales",
		"tableheadernew" : "Reportes Nuevos",
		"tableheaderclosed " :"Reportes Cerrados",
		"tableheaderdiscard" : "Reportes Descartados",
		"tableheaderassigned" : "Reportes Asignados",
		"generaltable": "General",
		"allcategories": "Todas las categorías",
		"ShogunInform" : "Informe Shogun Monitor:",
		"Inform" : "Informe: ",
		"Numberreport" : "Número de Denuncia",
		"tabledate" : "Fecha",
		"tablecategory" : "Categoría",
		"tablesubcategory" : "Subcategoría",
		"tableuser" : "Usuario",
		"tablestate": "Estado de Denuncia",
		"tablereason" : "Motivo de Cierre",
		"tableasign" : "Asignado",
		"tablepriority" :"Prioridad",
		"tabledescription" : "Descripción",
		"tablecomments" : "Comentarios",
		"Anonreport" : "Anónimo",
		"open" : "Abierto",
		"close" : "Cerrado",
		"discard" : "Descartado",
		"exporttable" : "Exportar Tabla",
		"exportreports" : "Exportar Reportes",
		"nopriority" : "Prioridad: Sin asignar",
		"lowpriority" : "Prioridad: Baja",
		"midpriority" : "Prioridad: Media",
		"highpriority" : "Prioridad: Alta",
		"warning" : "Advertencia",
		"warningmessage" : "No tiene los permisos para ver este reporte."
    }
};

export default Settings;
